export const LOGIN_EXTERNAL = "external/LOGIN_EXTERNAL";
export const BLOCK_URL_CHANGE = "external/URLCHANGE";

export const loginExternal = ({ accessToken, userNm, status }) => ({
	type: LOGIN_EXTERNAL,
	payload: {
		userNm: userNm,
		accessToken: accessToken,
		status: status,
	},
});

export const blockUrlChange = ({ targetIdx }) => ({
	type: BLOCK_URL_CHANGE,
	payload: {
		targetIdx: targetIdx,
	},
});
